import {
  FragmentScreenViewDTO,
  IFragmentFragmentScreenDTO,
} from 'business/models/Models';
import FragmentService from 'business/services/FragmentService';
import React, { useEffect, useMemo, useState } from 'react';
import { DropContentInfoCard } from './DropContentInfoCard';
import { RockMakerFragmentIcon } from '@fmlx/icons';
import { compareByNameWithNullsLast } from 'utils/Global';
import {
  EPrecisionType,
  PrecisionFormatter,
} from 'components/plateviewer/render/plate/plateviewer/constants';

interface Props {
  fragmentFragmentScreen: IFragmentFragmentScreenDTO[];
  fragmentVolume?: number;
  formatWithPrecision: PrecisionFormatter;
}

const fragmentService = new FragmentService();
export const FragmentInfo = (props: Props) => {
  const { fragmentFragmentScreen, fragmentVolume, formatWithPrecision } = props;
  const [fragments, setFragments] = useState<FragmentScreenViewDTO[]>([]);
  useEffect(() => {
    const fetchFragmentInfo = async () => {
      fragmentService.getFragmentsInfo(fragmentFragmentScreen).then((res) => {
        setFragments(res);
      });
    };
    if (fragmentFragmentScreen?.length) {
      fetchFragmentInfo();
    }
  }, [fragmentFragmentScreen]);

  const sortedFragments = useMemo(() => {
    return fragments.sort((a, b) =>
      compareByNameWithNullsLast(a.fragmentName, b.fragmentName),
    );
  }, [fragments]);

  return (
    <div className="flex flex-col gap-2">
      {sortedFragments.map((fragment, idx) => {
        const header = fragment.fragmentName;
        const contents: string[] = [
          `Conc: ${formatWithPrecision(
            fragment.workingConcentration,
            EPrecisionType.Concentration,
          )} mM, Size: ${fragment.size}, Volume: ${formatWithPrecision(
            fragmentVolume ?? 0,
            EPrecisionType.Volume,
          )} µL`,
          `Notes: ${fragment.notes}`,
        ];
        return (
          <DropContentInfoCard
            key={idx}
            header={header}
            contents={contents}
            icon={<RockMakerFragmentIcon customSize={36} />}
          />
        );
      })}
    </div>
  );
};
